import { render, staticRenderFns } from "./InfoAddress.vue?vue&type=template&id=5ecdaf16&scoped=true&"
import script from "./InfoAddress.vue?vue&type=script&lang=js&"
export * from "./InfoAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ecdaf16",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Projects\\Werk\\MarketingDbNEW\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ecdaf16')) {
      api.createRecord('5ecdaf16', component.options)
    } else {
      api.reload('5ecdaf16', component.options)
    }
    module.hot.accept("./InfoAddress.vue?vue&type=template&id=5ecdaf16&scoped=true&", function () {
      api.rerender('5ecdaf16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/DmVisualizer/Components/ChangeInfo/InfoAddress.vue"
export default component.exports